import { render, staticRenderFns } from "./InterfaceOne.vue?vue&type=template&id=936a13e6&scoped=true"
import script from "./InterfaceOne.vue?vue&type=script&lang=js"
export * from "./InterfaceOne.vue?vue&type=script&lang=js"
import style0 from "./InterfaceOne.vue?vue&type=style&index=0&id=936a13e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936a13e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('936a13e6')) {
      api.createRecord('936a13e6', component.options)
    } else {
      api.reload('936a13e6', component.options)
    }
    module.hot.accept("./InterfaceOne.vue?vue&type=template&id=936a13e6&scoped=true", function () {
      api.rerender('936a13e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/decorationPage/library/modules/Goods/ui/InterfaceOne.vue"
export default component.exports